import { Navigate } from "react-router-dom";

export const NotFound = () => <Navigate to="/" replace={true} />;
